module.exports = __webpack_public_path__ + "static/media/true.9b4579a0.svg";